/**
 * BlobFailureReason vocabulary — closed, cross-platform set for the map
 * vector-tile (.bin) BLE transfer. Must stay identical to the backend's copy
 * in `backend/reports/mini_map/index.js` and to the source enums documented
 * in `Companion-Apps/iOS/docs/Map/Analytics.md` (iOS `BlobFailureReason`) /
 * `Companion-Apps/Android/native/docs/Goggles/BLE/Analytics.md`
 * (`RekkieAnalytics.BlobFailureReason`).
 *
 * Colors are assigned once per key, not ranked by volume — unlike OTA
 * Attempts' near-unique raw reason strings, this is a closed enum, so
 * every reason keeps the same color across every fetch and every report.
 */

export const COMPLETED_COLOR = '#30d158';

export const BLOB_FAILURE_REASONS = [
  { key: 'crc_fail', label: 'CRC mismatch', color: '#ff375f' },
  { key: 'size_exceeded', label: 'Blob too large', color: '#ff9f0a' },
  { key: 'out_of_memory', label: 'Peripheral out of memory', color: '#bf5af2' },
  { key: 'write_fail', label: 'Peripheral write failure', color: '#ff6482' },
  { key: 'bad_request', label: 'Malformed request', color: '#ffd60a' },
  { key: 'invalid_map', label: 'Invalid map', color: '#d252ff' },
  { key: 'unknown_status', label: 'Unrecognized status byte', color: '#64d2ff' },
  { key: 'max_retries_exceeded', label: 'Chunk exhausted retries', color: '#5e5ce6' },
  { key: 'ready_timeout', label: 'Peripheral never sent READY', color: '#ac8e68' },
  { key: 'validation_timeout', label: 'Peripheral never validated transfer', color: '#ff453a' },
  { key: 'asset_missing', label: '.bin file missing from bundle', color: '#8e8e93' },
];

export const REASON_COLOR = Object.fromEntries(BLOB_FAILURE_REASONS.map((r) => [r.key, r.color]));
export const REASON_LABEL = Object.fromEntries(BLOB_FAILURE_REASONS.map((r) => [r.key, r.label]));
